<div class="flex justify-center px-4">
  <div class="container mx-auto">
    @if (!product) {
      <div class="flex justify-center items-center min-h-[50vh] mt-24 md:mt-32">
        <app-items-loading />
      </div>
    } @else {
      <div class="flex flex-col lg:flex-row md:mt-32 mt-24 gap-6 lg:gap-8 items-start">
        <div class="lg:w-5/12 flex flex-col items-center w-full h-fit">
          <div
            class="w-full aspect-square bg-white border border-gray-200 rounded-2xl overflow-hidden flex items-center justify-center"
          >
            <img
              [src]="selectedImage || '/placeholder.svg'"
              (error)="onImageError($event)"
              alt="Product"
              class="w-full h-full aspect-square object-cover rounded-2xl"
            />
          </div>

          <div class="flex gap-3 mt-3 overflow-x-auto w-full justify-center">
            <img
              *ngFor="let img of productImages"
              [src]="img"
              (error)="onImageError($event)"
              alt="Thumbnail"
              (click)="selectImage(img)"
              [style.borderColor]="selectedImage === img ? 'var(--primary)' : ''"
              class="w-20 h-20 aspect-square object-cover border-gray-300 rounded-xl border-2 cursor-pointer hover:border-[var(--primary)] transition flex-shrink-0"
            />
          </div>
        </div>

        <!-- Right: Product Details -->
        <div class="lg:w-7/12 bg-white border border-gray-200 rounded-2xl p-5 md:p-6 space-y-4 h-fit">
          <!-- Product Name & Price -->
          <div>
            <h1 class="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight">
              {{ product.name }}
            </h1>
            <div class="flex items-center gap-3 mt-2">
              <p class="text-2xl md:text-3xl font-bold text-[var(--primary)]">
                LKR {{ price }}
              </p>
              <p *ngIf="oldPrice" class="text-base text-gray-500 line-through">
                LKR {{ oldPrice }}
              </p>
            </div>
            <!-- Stock Display -->
            <p
              class="text-xs mt-1 font-semibold"
              [ngClass]="{
                'text-emerald-600': avaialbleQuantity > 5,
                'text-amber-500': avaialbleQuantity > 0 && avaialbleQuantity <= 5,
                'text-rose-600': avaialbleQuantity === 0,
              }"
            >
              @if (avaialbleQuantity > 0) {
                ✓ {{ avaialbleQuantity }} items available
              } @else {
                Out of stock
              }
            </p>
          </div>

          <!-- Product Description -->
          <p class="text-gray-600 text-sm leading-relaxed border-t border-gray-100 pt-3">{{ product.description }}</p>

          <!-- Options Grid (Color, Gender, Category, Theme, Sizes, Quantity - 3 Cols on Desktop) -->
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 border-t border-gray-100 pt-4">
            <!-- Color -->
            <div *ngIf="product.colors?.length">
              <h3 class="font-bold text-gray-900 text-sm mb-1.5">Color:</h3>
              <div class="flex gap-2">
                <div
                  *ngFor="let color of product.colors"
                  (click)="onColorChange(color)"
                  [style.backgroundColor]="color.code"
                  class="w-7 h-7 rounded-full cursor-pointer border-2 transition-transform hover:scale-110"
                  [ngClass]="{
                    'border-gray-300': selectedColor?.code !== color.code,
                    'border-[var(--primary)] ring-2 ring-[var(--primary)]/30': selectedColor?.code === color.code,
                  }"
                ></div>
              </div>
            </div>

            <!-- Gender -->
            <div *ngIf="product.gender">
              <h3 class="font-bold text-gray-900 text-sm mb-1.5">Gender:</h3>
              <div class="flex flex-wrap gap-2">
                <span
                  class="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-semibold border border-gray-200 capitalize"
                >
                  {{ product.gender }}
                </span>
              </div>
            </div>

            <!-- Categories -->
            <div *ngIf="product.productCategory">
              <h3 class="font-bold text-gray-900 text-sm mb-1.5">Product Category:</h3>
              <div class="flex flex-wrap gap-2">
                <span
                  class="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-semibold border border-gray-200"
                >
                  {{ product.productCategory }}
                </span>
              </div>
            </div>

            <!-- Design Themes -->
            <div *ngIf="product.designTheme">
              <h3 class="font-bold text-gray-900 text-sm mb-1.5">Design Theme:</h3>
              <div class="flex flex-wrap gap-2">
                <span
                  class="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-semibold border border-gray-200"
                >
                  {{ product.designTheme }}
                </span>
              </div>
            </div>

            <!-- Sizes -->
            @if (product.sizes.length !== 0) {
              <div>
                <h3 class="font-bold text-gray-900 text-sm mb-1.5">Sizes:</h3>
                <div class="flex flex-wrap gap-2">
                  <span
                    *ngFor="let size of product.sizes"
                    (click)="onSizeChange(size)"
                    [ngClass]="selectedSize === size ? 'bg-[var(--primary)] text-white border-[var(--primary)]' : 'border-gray-300'"
                  >
                    {{ size }}
                  </span>
                </div>
              </div>
            }

            <!-- Quantity Selector -->
            <div class="flex flex-col justify-start">
              <label class="font-bold text-gray-900 text-sm mb-1.5">Quantity:</label>
              <input
                type="number"
                [(ngModel)]="quantity"
                min="1"
                [max]="avaialbleQuantity"
                class="w-24 px-3 py-1.5 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--primary)] font-semibold text-center text-sm"
              />
            </div>
          </div>

          <!-- Add to Cart & Gift Box Buttons -->
          <div class="pt-4 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              [disabled]="addToCartLoading"
              class="w-full sm:w-auto px-8 py-3.5 group bg-[var(--primary)] text-white rounded-xl font-bold text-base cursor-pointer flex gap-2 justify-center items-center transition border border-[var(--primary)] hover:bg-gray-900 shadow-xs"
              (click)="addToCart(product!, quantity)"
            >
              @if (addToCartLoading) {
                <app-items-loading
                  size="w-5 h-5"
                  class="[&>svg>circle]:stroke-white [&>svg>path]:stroke-white"
                ></app-items-loading>
              } @else {
                <fa-icon [icon]="faCartPlus" class="w-5 h-5"></fa-icon>
              }
              Add to Cart
            </button>

            <button
              class="w-full sm:w-auto px-8 py-3.5 group bg-amber-50 text-amber-700 rounded-xl font-bold text-base cursor-pointer flex gap-2 justify-center items-center transition border border-amber-300 hover:bg-amber-500 hover:text-white hover:border-amber-500 shadow-xs"
              (click)="addToGiftBox()"
            >
              <fa-icon [icon]="faBoxOpen" class="w-5 h-5"></fa-icon>
              Add to Gift Box
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
